import { render, staticRenderFns } from "./CommandAssistant3.vue?vue&type=template&id=4563461c&scoped=true&"
import script from "./CommandAssistant3.vue?vue&type=script&lang=js&"
export * from "./CommandAssistant3.vue?vue&type=script&lang=js&"
import style0 from "./CommandAssistant3.vue?vue&type=style&index=0&id=4563461c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4563461c",
  null
  
)

export default component.exports